import { prop, path, reverse } from 'ramda';

import colorSorting from './strategies/colorSorting';
import dateSorting from './strategies/dateSorting';
import stringSorting from './strategies/stringSorting';

type SortOptions = [sortProp: string | Array<string>, sortOrder: 1 | -1, sortType?: string];

const strategies = {
  default: stringSorting,
  color: colorSorting,
  date: dateSorting,
  string: stringSorting,
};

const sortingStrategy = (strategy: string) => strategies[strategy] || strategies.default;

/**
 * Sorts list of objects.
 *
 * @param sorting Sortoptions.
 * @param items List to be sorted.
 * @returns Sorted list.
 */
export const sortItems = <T>([sortProp, sortOrder, sortType]: SortOptions, items: Array<T>): Array<T> => {
  if (!items) return null;

  const selector = typeof sortProp === 'string' ? prop(sortProp) : path(sortProp);

  const sorted = sortingStrategy(sortType)(selector, items);

  return sortOrder === 1 ? sorted : reverse(sorted);
};

export default sortItems;
